module.exports = __webpack_public_path__ + "img/portfolio-5.8163025a.jpg";